import { WebView } from 'components/web_view'
import { Page } from 'components/Page'
import { useStats } from './lib/ctx/stats'
import { Stats } from './Stats'
import { StatsError, StatsLoader, StatsShareModal } from './components'
import { css, useTheme } from '@fable/theme'
import { statsColors } from './lib/theme'
import { analytics } from 'segment_analytics'
import { useStatsPermission } from './lib/hooks'
import { useMotionValueEvent, useScroll } from 'framer-motion'
import { useRef } from 'react'
import { StatsDebug } from './components/stats_debug'
import { StatsProviders } from './StatsProviders'
import { usePageHashScroll } from 'hooks'

/**
 *
 * NOTE: This is a legacy page that is being replaced
 * by the new StatsProfilePage in /webview directory.
 *
 * Should be deprecated once the new page is fully implemented.
 */
export const StatsPageContent = () => {
  const [stats, isProfileView, status] = useStats((s) => [
    s.stats,
    s.isProfileView,
    s.status,
  ])
  const { scrollY } = useScroll()
  const scrolled = useRef(false)
  const { colors } = useTheme()
  const { isPrivate, isStatsOwner } = useStatsPermission()

  useMotionValueEvent(scrollY, 'change', (pos) => {
    if (isProfileView && !scrolled.current && pos > 0) {
      analytics.events.stats.statsScrolled()
      scrolled.current = true
    }
  })

  usePageHashScroll({ offset: 17 })

  const getContent = () => {
    if (status === 'loading') return <StatsLoader />

    if (status === 'error') {
      const text = `Sorry, we could not display ${
        isStatsOwner ? 'your' : "this user's"
      } stats.`
      return <StatsError text={text} allowRetry />
    }

    if (isPrivate) {
      return <StatsError text="This user's stats have been set to Private." />
    }

    return <Stats />
  }

  return (
    <Page
      className={css`
        background-color: ${status === 'loading'
          ? statsColors.base.pink
          : colors.uiWhite};
        height: 100%;
        position: relative;
        user-select: none;
      `}
      head={{
        title: stats?.user ? `${stats.user.display_name}'s Stats` : 'Stats',
      }}
    >
      {getContent()}
      <StatsDebug />
      <StatsShareModal />
    </Page>
  )
}

const StatsLegacyPage = () => {
  const { colors } = useTheme()

  return (
    <StatsProviders>
      <WebView id="stats" backgroundColor={colors.uiWhite}>
        <StatsPageContent />
      </WebView>
    </StatsProviders>
  )
}

export default StatsLegacyPage
